//import {router} from '../../../main'


import { API_HOST, API_PATH } from '../../../config/_entrypoint';
// URL and endpoint constants
const API_URL = API_HOST+API_PATH;
const LOGIN_URL = API_URL + 'login_check'


export default {

    // User object will let us check authentication status
    user: {
        authenticated: false
    },

    // Send a request to the login URL and save the returned JWT
    login(context, creds, redirect) {

        context.$http.post(LOGIN_URL, creds).then(data => {
            localStorage.setItem('token', data.body.token);
            localStorage.setItem('user', creds.email);
            this.user.authenticated = true;
            $(context.$refs.loginModal).modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            // Redirect to a specified route

            if(redirect) {
                let previousRoute= localStorage.getItem('previousRoute');
                context.$router.replace(previousRoute ? previousRoute : '/');
                context.$parent.user=localStorage.getItem('user');
                window.ccc=context
                //console.log(context.$parent);

            }

        },data => {
            context.error=data.body.message+' ('+data.body.code+')';

            //throw(new Error(data));

        })
    },


    // To log out, we just need to remove the token
    logout() {
        localStorage.removeItem('token');
        this.user.authenticated = false
    },

    checkAuth() {
        var jwt = localStorage.getItem('token');
        if(jwt) {
            this.user.authenticated = true
        }
        else {
            this.user.authenticated = false
        }
    },

    // The object to be passed as a header for authenticated requests
    getAuthHeader() {
        return {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js